import { Check } from "@mui/icons-material";
import { Button, TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import { useState } from "react";
import { url } from "../../url";
import styles from "./FeedbackForm.module.scss";

const FeedbackForm = () => {
  const [state, setState] = useState({
    description: "",
    email: "",
  });

  const [showAlert, setShowAlert] = useState(false);

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
  };

  const onClickButton = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        url + "/feedback",
        {
          email: state.email,
          description: state.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setShowAlert(true);
      setState({ description: "", email: "" });
      setTimeout(() => setShowAlert(false), 3500);
    } catch (err) {
      console.log("Error sending feedback", err);
    }
  };

  return (
    <>
      <div className={styles._form_container}>
        <h2 className={styles.header}>We value your feedback</h2>
        <p className={styles.subtext}>
          Let us know what you think or if you encountered any issues.
          <br />
          Your feedback helps us improve.
        </p>
        <form className={styles._form_3d} onSubmit={onClickButton}>
          <div className={styles._form_group}>
            <TextField
              label="Your message..."
              multiline
              rows={7}
              variant="outlined"
              fullWidth
              id="description"
              name="description"
              onChange={onChangeInput}
              value={state.description}
              required
            />
          </div>
          <div className={styles._form_group_email}>
            <TextField
              label="Email (optional)"
              type="email"
              variant="outlined"
              fullWidth
              id="email"
              name="email"
              onChange={onChangeInput}
              value={state.email}
              placeholder="Enter your email if you want a reply"
            />
          </div>
          <div className={styles._button_container}>
            <Button
              className={styles._form_button}
              type="submit"
              variant="contained"
              size="large"
            >
              Send feedback
            </Button>
          </div>
        </form>
      </div>
      {showAlert && (
        <div className={styles["alert-container"]}>
          <Alert icon={<Check fontSize="inherit" />} severity="success">
            <h4>Thank you for your feedback!</h4>
          </Alert>
        </div>
      )}
    </>
  );
};

export default FeedbackForm;
